import React from 'react';
import { client } from '../../__graphql__/clientCluster';
import { ApolloProvider } from '@apollo/client';

export const ApolloWrapper: React.FC = ({ children }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
